module.exports = __webpack_public_path__ + "static/media/German_Loader.099d4936.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/German_Loader.gif
// module id = 742
// module chunks = 0